<template>
  <section class="viewsrhqyClockManage_CheckMonitor space-y-4 p-4">
    <viewTitle title="业务管理 / 发货打卡管理 / 打卡监控" :showReturn="true">
      <template slot="return">
        <el-button @click="onExport" v-has="['c-clock-monitoring-export']" type="primary" size="small">导出excel
        </el-button>
      </template>
    </viewTitle>
    <el-form :inline="true" :model="queryParam" class="search-form-inline">
      <el-form-item label="送货单号">
        <el-input
            clearable
            v-model="queryParam.deliver_code"
            placeholder="请输入送货单号"
            class="w-44"
        ></el-input>
      </el-form-item>
      <el-form-item label="车牌号">
        <el-input
            clearable
            v-model="queryParam.license_plate"
            placeholder="请输入车牌号"
            class="w-44"
        ></el-input>
      </el-form-item>
      <el-form-item label="木片厂名">
        <el-input
            clearable
            v-model="queryParam.chip_name"
            placeholder="请输入木片厂名"
            class="w-48"
        ></el-input>
      </el-form-item>
      <el-form-item label="木片厂编号">
        <el-input
            clearable
            v-model="queryParam.chip_code"
            placeholder="请输入木片厂编号"
            class="w-48"
        ></el-input>
      </el-form-item>
      <el-form-item label="供应商名称">
        <el-input
            clearable
            v-model="queryParam.supplier_name"
            placeholder="请输入供应商名称"
            class="w-48"
        ></el-input>
      </el-form-item>
      <el-form-item label="供应商编号">
        <el-input
            clearable
            v-model="queryParam.supplier_code"
            placeholder="请输入供应商编号"
            class="w-48"
        ></el-input>
      </el-form-item>
      <el-form-item label="打卡时间">
        <el-date-picker
            class="!w-96"
            style="margin-bottom: 10px;"
            v-model="timeRange"
            type="datetimerange"
            align="right"
            unlink-panels
            range-separator="至"
            :default-time="['00:00:00', '23:59:59']"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="timestamp"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="基地" v-if="baseInfo.is_main_com === 1">
        <el-select class="w-60" clearable v-model="queryParam.base_id">
          <el-option
              v-for="item in com_list"
              :key="item.com_id"
              :label="item.com_name"
              :value="item.com_id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="打卡前停留时长">
        <el-select placeholder="请选择打卡前停留时长" class="w-60" clearable
                   v-model="queryParam.before_clock_stop_time">
          <el-option v-for="item in duration_list" :key="item.value" v-bind="item"/>
        </el-select>
      </el-form-item>
      <el-form-item label="停留时长">
        <el-select placeholder="请选择停留时长" class="w-60" clearable v-model="queryParam.stop_time">
          <el-option v-for="item in duration_list" :key="item.value" v-bind="item"/>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
            @click="refreshData"
            type="primary"
            size="small"
        >刷新数据
        </el-button
        >
        <el-button
            @click="onReset"
            size="small"
        >重置
        </el-button
        >
      </el-form-item>
    </el-form>
    <c-table
        class="mt-4"
        :data="dataSource"
        :columns="columns"
        :query.sync="pagintion"
        :total="total"
        row-key="id"
        @loadPage="loadData"
    >
      <template slot="clock_time" slot-scope="{row}">
        {{ row.clock_time|timeFormat }}
      </template>
      <template slot="position_source" slot-scope="{row}">
        {{ row.position_source == 1 ? '北斗' : 'APP' }}
      </template>
      <template slot="stopAndClock" slot-scope="{row}">
        <span v-if="row.begin_stop_time && row.clock_time">
          {{ row.begin_stop_time|timeFormat }}~{{ row.clock_time|timeFormat }}
        </span>
      </template>
    </c-table>
  </section>
</template>

<script>
import moment from "moment";
import initListMinxin from "@/mixins/jl/initListMinxin";
import {mapGetters} from 'vuex';

export default {
  data() {
    return {
      duration_list: [
        {label: '30分钟内', value: 1800},
        {label: '60分钟内', value: 3600},
        {label: '120分钟内', value: 7200}
      ],
      columns: [
        {label: "送货单号", prop: "deliver_code"},
        {label: "木片厂名", prop: "chip_name"},
        {label: "车牌号", prop: "license_plate"},
        {label: "打卡时间", prop: "clock_time"},
        {label: "来源", prop: "position_source"},
        {label: "停车地址", prop: "stop_address"},
        {label: "停车时间-打卡时间", prop: "stopAndClock"},
        {
          label: "打卡前停留时长（分钟）",
          prop: "before_clock_stop_time",
          formatData: row => {
            const m = moment.duration(row.before_clock_stop_time, 'seconds').asMinutes();
            return Math.ceil(m);
          }
        },
        {
          label: "停留时长（分钟）",
          prop: "stop_time",
          formatData: row => {
            const m = moment.duration(row.stop_time, 'seconds').asMinutes();
            return Math.ceil(m);
          }
        },
        {
          label: ">=1H + >=1公里",
          prop: "after_1hour_over_1km",
          formatData: row => row.after_1hour_over_1km === null ? null : (row.after_1hour_over_1km === 1 ? '是' : '否')
        },
        {
          label: ">=4H + >=5公里", prop: "after_4hour_over_5km",
          formatData: row => row.after_4hour_over_5km === null ? null : (row.after_4hour_over_5km === 1 ? '是' : '否')
        },
        {
          label: ">=12H + >=5公里", prop: "after_12hour_over_5km",
          formatData: row => row.after_12hour_over_5km === null ? null : (row.after_12hour_over_5km === 1 ? '是' : '否')
        }
      ],
      exportDataEvent: params => {
        const {begin_time, end_time, ...data} = params;
        return this.$common.http({
          url: "/api/queue/admin/clock_monitoring_export",
          data: {
            ...data,
            begin_clock_time: begin_time,
            end_clock_time: end_time
          },
          noLoading: true
        });
      },
      fetchDataEvent: params => {
        const {begin_time, end_time, ...data} = params;
        return this.$common.http({
          url: "/api/queue/admin/clock_monitoring_list",
          data: {
            ...data,
            begin_clock_time: begin_time,
            end_clock_time: end_time
          }
        })
      }
    };
  },
  computed: {
    ...mapGetters(["baseInfo"])
  },
  mixins: [initListMinxin],

  methods: {
    // 生成默认查询条件，首屏和重置都限制在最近 7 天内，避免误触发全量查询。
    getDefaultQueryParam() {
      const beginTime = moment().startOf("days").subtract("7", "days");
      const endTime = moment().endOf("days");

      return {
        deliver_code: "",
        license_plate: "",
        chip_name: "",
        chip_code: "",
        supplier_name: "",
        supplier_code: "",
        base_id: "",
        before_clock_stop_time: "",
        stop_time: "",
        begin_time: beginTime.format("X"),
        end_time: endTime.format("X")
      };
    },
    // 重置筛选条件时恢复默认时间窗口，避免清空时间后形成大范围查询。
    onReset() {
      this.pagintion.page = 1;
      this.queryParam = this.getDefaultQueryParam();
      this.timeRange = [
        moment.unix(this.queryParam.begin_time).valueOf(),
        moment.unix(this.queryParam.end_time).valueOf()
      ];
      this.onSearch();
    }
  },

  created() {
    // 生成默认查询条件，首屏和重置都限制在最近 7 天内，避免误触发全量查询。
    this.queryParam = this.getDefaultQueryParam();
    this.timeRange = [
      moment.unix(this.queryParam.begin_time).valueOf(),
      moment.unix(this.queryParam.end_time).valueOf()
    ];
    this.$nextTick(() => {
      this.refreshData();
    });
  }
};
</script>
